import styled from 'styled-components';

export const HelpContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }: {theme: any}) => theme.neutralLighter};
  box-shadow: inset 0 4px 0 0 ${({ theme }: {theme: any}) => theme.themePrimary},
    1px 1px 8px rgba(0, 0, 0, 0.05);
  border-radius: 1rem;
  padding: 2rem 1rem;
`;

export const HelpHeader = styled.div`
  position: relative;
  display: flex;
  gap: 16px;
  width: 100%;
  padding: 0 20px 20px;
  align-items: center;

  h1 {
    font: 700 1.5rem/1.8rem 'Segoe UI', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.black};
  }

  h2 {
    border-left: 1px solid #dfdfdf;
    padding-left: 12px;
    font: 400 0.9rem/1.8rem 'Segoe UI', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.neutralSecondary};
  }

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 4px;
    border-radius: 16px;
    left: 0;
    bottom: 0;
    opacity: 0.1;
    background: ${({ theme }: {theme: any}) => theme.black};
  }

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 0.5rem;

    h2 {
      border: none;
      padding: 0;
      line-height: 1rem;
    }
  }
`;

export const HelpContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 1rem;

  section {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding-top: 1rem;

    p {
      font: 300 0.8rem/1.1rem 'Segoe UI', sans-serif;
      color: ${({ theme }: {theme: any}) => theme.black};

      a {
        font: inherit;
        color: ${({ theme }: {theme: any}) => theme.themePrimary};
      }
    }

    h2 {
      font: 700 1rem/1rem 'Segoe UI', sans-serif;
      color: ${({ theme }: {theme: any}) => theme.black};
    }

    form {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      label {
        font: 700 0.9rem/1rem 'Segoe UI', sans-serif;
        color: ${({ theme }: {theme: any}) => theme.neutralTertiary};
        padding: 1rem 0 0.5rem;
      }

      select {
        padding: 0.25rem 0.5rem;
        border-radius: 6px;
        font: 300 0.8rem/1.1rem 'Segoe UI', sans-serif;
        background: ${({ theme }: {theme: any}) => theme.neutralLighter};
        color: ${({ theme }: {theme: any}) => theme.black};

        &:focus {
          border: 1px solid ${({ theme }: {theme: any}) => theme.themePrimary};
        }
      }

      textarea {
        background: ${({ theme }: {theme: any}) => theme.neutralLighter};
        color: ${({ theme }: {theme: any}) => theme.black};
        width: 100%;
        height: 200px;
        border: 3px dotted ${({ theme }: {theme: any}) => theme.neutralQuaternary};
        border-radius: 12px;
        padding: 1rem;
      }

      & + section {
        border-top: 1px solid #dfdfdf;
      }

      footer {
        display: flex;
        gap: 1rem;
        align-items: center;
        margin-top: 1rem;

        button {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 10px 1.2rem;
          border-radius: 6px;
          border: none;
          background: ${({ theme }: {theme: any}) => theme.themePrimary};
          color: #fff;

          font: 500 1rem/1rem 'Segoe UI', sans-serif;
          cursor: pointer;

          transition: all 0.2s ease;

          &:hover {
            background: ${({ theme }: {theme: any}) => theme.themeTertiary};
          }
        }

        span.statusMessage {
          display: flex;
          align-items: center;
          font: 400 0.8rem/1.1rem 'Segoe UI', sans-serif;
          gap: 0.2rem;

          &#messagesent {
            color: #5cb85c;
          }

          &#messagefailed {
            color: #fc100d;
          }
        }
      }
    }
  }
`;
